<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <!-- <a class="navbar-brand" href="#">Dashboard</a> -->
      <button type="button" class="navbar-toggler navbar-toggler-right" :class="{ toggled: $sidebar.showSidebar }"
        aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <ul class="nav navbar-nav mr-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" href="#" data-toggle="dropdown">
              <i class="nc-icon nc-palette"></i>
            </a>
          </li> -->
          <!-- <base-dropdown tag="li">
            <template slot="title">
              <i class="nc-icon nc-planet"></i>
              <b class="caret"></b>
              <span class="notification">5</span>
            </template>
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </base-dropdown> -->
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nc-icon nc-zoom-split"></i>
              <span class="d-lg-block">&nbsp;Search</span>
            </a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto">
          <!-- <li class="nav-item">
            <a class="nav-link" @click="loadingTest()" style="cursor: pointer">
              Account
            </a>
          </li> -->
          <!-- <base-dropdown title="Dropdown">
            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <a class="dropdown-item" href="#">Another action</a>
            <a class="dropdown-item" href="#">Something</a>
            <div class="divider"></div>
            <a class="dropdown-item" href="#">Separated link</a>
          </base-dropdown> -->
          <li class="nav-item" v-if="routeName == 'ShowExp'">
            <a href="" class="nav-link" @click="goBack()" onclick="return false">
              بازگشت
              <i class="fas fa-arrow-right"></i>
            </a>
          </li>
          <li class="nav-item">
            <a href="" class="nav-link" @click="logOut()" onclick="return false;">
              Log out
              <i class="fas fa-sign-out-alt"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import axios from 'axios';
import { Apis } from '../constants';

export default {
  computed: {
    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  data() {
    return {
      activeNotifications: false
    }
  },
  methods: {
    loadingTest() {
      this.$loading.show();
      setTimeout(() => {
        this.$loading.hide();
      }, 3000);
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown() {
      this.activeNotifications = false
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },

    goBack() {
      this.$router.go(-1);
    },

    logOut() {
      this.$loading.show();
      axios.post(Apis.logout, {
        Credential: true
      }).then(response => {
        console.log("logout response: ", response.data);
        this.clearLoginData();
        this.$loading.hide();
      }).catch(err => {
        console.log("error: ", err);
        this.$loading.hide();
      });
    },

    clearLoginData() {
      try {
        localStorage.removeItem('userID');
        localStorage.removeItem('session_id');
        localStorage.removeItem('username');
        Cookies.remove('userID');
        Cookies.remove('session_id');
      } catch (error) {
        console.log("error: ", error);
      }
      this.$router.push({ name: 'login' });
    }
  }
}

</script>
<style scoped>
.nav-link i {
  line-height: 20px;
  margin-left: 5px;

}
</style>
